import { useOutletContext } from "react-router-dom";
import { allows, type Module, type ModuleLevel } from "@kickwin/shared";
import type { Bot, Me } from "./api";

export interface ShellContext {
  me: Me;
  bots: Bot[];
}

export function useMe(): Me {
  return useOutletContext<ShellContext>().me;
}

/**
 * Whether this person's role allows a module at a level (decision 42) — to
 * decide what to show. Presentation only: the server checks every request.
 */
export function useCan<M extends Module>(module: M, level: ModuleLevel<M>): boolean {
  return allows(useMe().permissions, module, level);
}
